export default __webpack_public_path__ + "static/media/commerce.314caa26.jpg";